import React from "react";
import { createRoot } from "react-dom/client";

import "./styles.css";
import { HomepageApp } from "./homepage";

declare global {
  interface Window {
    TBD_HOMEPAGE_DATA?: unknown;
  }
}

const rootEl = document.getElementById("tbd-homepage-app");
if (rootEl) {
  const root = createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <HomepageApp data={window.TBD_HOMEPAGE_DATA} />
    </React.StrictMode>
  );
}

